import React from 'react'
import PropTypes from 'prop-types'

const WIDTH = 98
const HEIGHT = 50
const RADIUS = 36
const STROKE_WIDTH = 22
const ARC_LENGTH = Math.PI * RADIUS
const CENTER_X = WIDTH / 2
const ARC_PATH = `M ${CENTER_X - RADIUS} ${HEIGHT} A ${RADIUS} ${RADIUS} 0 0 1 ${CENTER_X + RADIUS} ${HEIGHT}`

const DEFAULT_COLORS = {
  track: '#e5e7eb',
  success: '#2cc675',
  warning: '#ec8e00',
  danger: '#e35542'
}

const DEFAULT_THRESHOLDS = { success: 70, warning: 30 }

const clampPercent = value => {
  if (value === null || typeof value === 'undefined' || Number.isNaN(value))
    return 0
  return Math.max(0, Math.min(100, value))
}

const pickColor = (value, thresholds, colors) => {
  if (value === null || typeof value === 'undefined')
    return colors.track
  if (value >= thresholds.success)
    return colors.success
  if (value >= thresholds.warning)
    return colors.warning
  return colors.danger
}

const SemiCircularGauge = ({ ariaLabel, value, thresholds, colors }) => {
  const mergedColors = { ...DEFAULT_COLORS, ...colors }
  const mergedThresholds = { ...DEFAULT_THRESHOLDS, ...thresholds }
  const filled = clampPercent(value) / 100 * ARC_LENGTH
  return (
    <svg
      aria-label={ariaLabel}
      className="tw:shrink-0"
      fill="none"
      height={HEIGHT}
      role="img"
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      width={WIDTH}
    >
      <path d={ARC_PATH} stroke={mergedColors.track} strokeWidth={STROKE_WIDTH} />
      <path
        d={ARC_PATH}
        stroke={pickColor(value, mergedThresholds, mergedColors)}
        strokeDasharray={`${filled} ${ARC_LENGTH}`}
        strokeWidth={STROKE_WIDTH}
      />
    </svg>
  )
}

SemiCircularGauge.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  colors: PropTypes.shape({
    danger: PropTypes.string,
    success: PropTypes.string,
    track: PropTypes.string,
    warning: PropTypes.string
  }),
  thresholds: PropTypes.shape({
    success: PropTypes.number,
    warning: PropTypes.number
  }),
  value: PropTypes.number
}

SemiCircularGauge.defaultProps = {
  colors: null,
  thresholds: null,
  value: null
}

export default SemiCircularGauge
